import { fetchData } from './fetchData';
import { Reason } from '../data/Reason';

function reason(): Promise<Reason[]> {
    return fetchData('api/reason', {
        method: 'POST',
        body: JSON.stringify({}),
    })
        .then((res) => res.json())
        .then((resData: Reason[]) => resData);
}

export { reason };
